import { motion } from "motion/react";
import { BookOpen, Trees, MapPin, Building2, Mountain } from "lucide-react";

const pillars = [
  {
    icon: BookOpen,
    title: "Methodology",
    description:
      "We are a multi-cultural school that upholds strong Christian values. Our commitment to developing leadership, teamwork and offering quality education, encourages excellent performance and independence.",
    color: "from-red-500 to-red-600",
  },
  {
    icon: Trees,
    title: "Environment",
    description:
      "Our rich history, strong school culture, and ethos allow all children irrespective of their diversity and backgrounds an opportunity to be open, friendly and confident yet still embrace their individuality; preparing them to face the future with confidence.",
    color: "from-blue-500 to-blue-600",
  },
  {
    icon: MapPin,
    title: "Location",
    description:
      "Hilltop is located in cosmopolitan Kitale; 5km North of Kitale Town in Trans Nzoia County. Hilltop is in a serene farm environment off the Endebess Namanjalala road Junction, away from the hustle and bustle of the town center.",
    color: "from-red-500 to-red-600",
  },
  {
    icon: Building2,
    title: "Facilities",
    description:
      "Hilltop offers modern academic, boarding, and recreational facilities to support holistic development.",
    color: "from-blue-500 to-blue-600",
  },
  {
    icon: Mountain,
    title: "Landscape",
    description:
      "As the name suggests, Hilltop overlooks the beautiful scenic peaks of Mt Elgon to the South, The Cherangani Hills to the North and the Kachiliba Hills to the West.",
    color: "from-red-500 to-red-600",
  },
];

export function WhatDrivesUs() {
  return (
    <section
      id="about"
      className="py-24 bg-gradient-to-b from-slate-50 to-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="inline-block px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-medium mb-4">
            Shaping the Future
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-6">
            What Drives Us
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Our commitment to excellence is built on five foundational pillars
            that guide everything we do.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
          {pillars.map((pillar, index) => (
            <motion.div
              key={pillar.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group"
            >
              <div className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-xl transition-all duration-300 h-full border border-slate-100 hover:border-transparent hover:-translate-y-2">
                <div
                  className={`w-14 h-14 rounded-xl bg-gradient-to-br ${pillar.color} flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300`}
                >
                  <pillar.icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-3">
                  {pillar.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed">
                  {pillar.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
